import Component from './z-switch.vue';
export default Component;
